import { FiltersButton } from '#/shared/ui/filters-button'
import type { ShipmentListFiltersState } from '../lib/use-shipment-list-filters'
import { SHIPMENT_FILTERS_PANEL_ID } from './shipment-filters-panel'

interface ShipmentFiltersButtonProps {
  state: ShipmentListFiltersState
  disabled?: boolean
}

/**
 * Toggle for the inline `ShipmentFiltersPanel`: the plain filters button with
 * the applied-filter count. Clicking it slides the panel open between the
 * toolbar and the table (no popover) — the panel is rendered by the page via
 * the toolbar's `filtersPanel` slot, off the same `state` object.
 */
export function ShipmentFiltersButton({
  state,
  disabled,
}: ShipmentFiltersButtonProps) {
  return (
    // The wrapper is the anchor the ShipmentFiltersPanel's pointer arrow
    // measures against — keep the attribute on whatever wraps the trigger.
    <span data-shipment-filters-trigger className="inline-flex w-fit">
      <FiltersButton
        count={state.count}
        disabled={disabled}
        onClick={() => state.setOpen(!state.isOpen)}
        ariaExpanded={state.isOpen}
        ariaControls={SHIPMENT_FILTERS_PANEL_ID}
      />
    </span>
  )
}
